import { connect } from "react-redux";
import { withRouter } from "react-router";
import { injectIntl } from "react-intl";

import { get } from "../../actions/general";
import taskCompleted from "../../store/plan/actions/taskCompleted";
import { changeStudentColors, changeStudentPitchNotation, changeStudentRhythmSyllableTypes, changeStudentReversedToneset, changeStudentSolfaAudio, changeStudentSolfaShort, changeStudentSolfaKam } from "../../store/user/actions";

import { SeoRenderer } from "../../../common/helpers/seo";

import Join from "./loadable";
import { Store } from "redux";

const mapDispatchToProps = {
    get,
    taskCompleted,
    changeStudentColors,
    changeStudentPitchNotation,
    changeStudentRhythmSyllableTypes,
    changeStudentReversedToneset,
    changeStudentSolfaShort,
    changeStudentSolfaAudio,
    changeStudentSolfaKam,
};

export default {
    component: withRouter(connect(null, mapDispatchToProps)(injectIntl(Join))),
    renderSeo: (store: Store, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: allMessage.classroom, allMessage, lang });
    },
};
